import React from 'react';
import classnames from 'classnames';
import { ProductFamiliesPropType } from '@propTypes';
import { string } from 'prop-types';
import QuickAccessFamily from '../QuickAccessFamily';

import styles from './styles/index.module.scss';

const QuickAccessFamilyContainer = ({ families, className }) => {
  const rootClassName = classnames(styles.root, className);
  /**
   * This component was initially rendered client side
   * with user personnalization in mind.
   * However, it introduced a CLS issue (incident #20201022-250-manomano)
   * as the height was not reserved.
   * As we are about to migrate this component in SPArtacUX and the user customization
   * is not yet done, we decided to render it server-side to prevent any issue.
   */
  return (
    <div className={rootClassName}>
      {families.map(({ level, name, url }) => (
        <QuickAccessFamily level={level} name={name} url={url} key={name} />
      ))}
    </div>
  );
};

QuickAccessFamilyContainer.propTypes = {
  families: ProductFamiliesPropType.isRequired,
  className: string,
};

QuickAccessFamilyContainer.defaultProps = {
  className: null,
};

QuickAccessFamilyContainer.displayName = 'QuickAccessFamilyContainer';

export default QuickAccessFamilyContainer;
